"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * @function phoneReducer
 * @param state
 * @param action
 * @returns name state
 */
var phones_1 = require("../../actions/phones");
function phoneReducer(state, action) {
    if (state === void 0) { state = phones_1.DefaultState; }
    switch (true) {
        case action.type.includes(phones_1.BUILD_PHONE): {
            var newState = Object.assign({}, state);
            newState.phones = action.phones.phones;
            newState.countries = action.phones.countries;
            if (action.phones.ppcSynchronyDeeplinks) {
                newState.ppcSynchronyDeeplinks =
                    action.phones.ppcSynchronyDeeplinks;
            }
            return newState;
        }
        case action.type.includes(phones_1.CHANGE_PHONE): {
            var newState = Object.assign({}, state);
            newState.phones = action.phones.phones;
            newState.countries = action.phones.countries;
            if (action.phones.ppcSynchronyDeeplinks) {
                newState.ppcSynchronyDeeplinks =
                    action.phones.ppcSynchronyDeeplinks;
            }
            return newState;
        }
        case action.type.includes(phones_1.REMOVE_PHONE): {
            var newState = Object.assign({}, state);
            newState.phones = action.phones.phones;
            newState.countries = action.phones.countries;
            return newState;
        }
        case action.type.includes(phones_1.CHANGE_PRIMARY_PHONE): {
            return tslib_1.__assign(tslib_1.__assign({}, state), { changePrimaryType: action.changePrimaryType });
        }
        case action.type.includes(phones_1.TYPE_ACTION):
            return tslib_1.__assign(tslib_1.__assign({}, state), { typeOfAction: action.typeOfAction });
        case action.type.includes(phones_1.REMOVE_TOAST): {
            var newState = Object.assign({}, state);
            newState.typeOfAction = action.typeOfAction;
            return newState;
        }
        default:
            return state;
    }
}
exports.default = phoneReducer;
